<template>
  <footer class="footer">
    <div class="container" aria-label="底部菜单栏" wzades="底部菜单栏">
      <!--<div class="footer-links">
      
        <div class="footer-links-item">
          <a class="footer-links-gov" target="_blank" href="http://www.gov.cn/">中国政府网</a>
        </div>
        &nbsp;
        
        <template v-for="(item, i) in siteData">
          <div class="footer-links-split" :key="2*i"></div>
          &nbsp;<div class="footer-links-item" :key="2*i+1">
            <el-dropdown trigger="click" placement="bottom-end">
              <span class="el-dropdown-link">
                {{ item.title }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(site, index) in item.list" :to="site.href" :disabled="site.disabled" :key="index">{{ site.name }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>&nbsp;
        </template>
      </div>-->
      
      <el-row class="footer-nav-wrapper" :gutter="60">
        <el-col :span="6" class="gd-col gd-col-3">
          <div class="footer-nav footer-nav-sitemap">
            <div class="footer-nav-hd">
              <h3 class="footer-nav-title">网站信息</h3>
            </div>
            <div class="footer-nav-bd pub-fix">
              <a href="//www.gdzwfw.gov.cn/portal/about-me" class="footer-nav-link">网站介绍</a>
              <a href="//www.gdzwfw.gov.cn/portal/suggest/advice" class="footer-nav-link">服务建议</a>
            </div>
          </div>
        </el-col>

        <el-col :span="6" class="gd-col gd-col-3">
          <div class="footer-nav footer-nav-contact">
            <div class="footer-nav-hd">
              <h3 class="footer-nav-title">联系我们</h3>
            </div>
            <div class="footer-nav-bd pub-fix">
              <div class="footer-contact">
                <div class="footer-contact-tel">12345</div>
                <div class="footer-contact-hint">&nbsp;</div>
              </div>
              <a href="//www.gdzwfw.gov.cn/portal/contact-us" class="footer-nav-link">联系信息</a>
            </div>
          </div>
        </el-col>

        <el-col :span="6" class="gd-col gd-col-3">
          <div class="footer-mp">
            <a href="javascript:;" class="footer-mp-item">
              广东省人民政府门户网站
              <span class="footer-mp-item-hover">
                <b class="qrcode-gov"></b>
                <i>广东省人民政府门户网站</i>
              </span>
            </a>
            <a href="javascript:;" class="footer-mp-item">
              广东政务服务公众号
              <span class="footer-mp-item-hover">
                <b class="qrcode-mp"></b>
                <i>广东政务服务公众号</i>
              </span>
            </a>
            <a href="javascript:;" class="footer-mp-item">
              广东政务服务APP
              <span class="footer-mp-item-hover">
                <b class="qrcode-app"></b>
                <i>广东政务服务APP</i>
              </span>
            </a>
          </div>
        </el-col>

        <el-col :span="6" class="gd-col gd-col-3">
          <div class="support">
            <a href="javascript:;" class="footer-mp-item support-minapp">
              粤省事小程序
              <span class="footer-mp-item-hover">
                <b class="qrcode-minapp"></b>
                <i>粤省事小程序码</i>
              </span>
            </a>
            <a class="support-link" href="javascript://" @click="onFeedbackClick">
              <img src="~@/assets/image/layout/cavil-grey.jpg" title="点击跳转到政府找错网" alt="点击跳转到政府找错网"> 
            </a>
            <a class="support-party" title="点击跳转网站标识证书" href="http://bszs.conac.cn/sitename?method=show&id=61643BF620EB1A7AE053022E1AAC1CB6" target="_blank">
              <img src="~@/assets/image/layout/red.png" title="点击跳转网站标识证书" alt="点击跳转网站标识证书">
            </a>
          </div>
        </el-col>

      </el-row>
      
      
    </div>

    <div class="footer-copyright pub-fix">
      <div class="container">
        <div class="footer-copyright-left">
          <span style="margin-right: 20px;">
            主办：<a target="_blank" href="http://www.gd.gov.cn/">广东省人民政府办公厅</a>
          </span>
          <span>
            承办：<a target="_blank" href="http://www.digitalgd.com.cn">数字广东网络建设有限公司</a>
          </span>
        </div>
        <div class="footer-copyright-right">版权所有：<a href="//www.gdzwfw.gov.cn/">广东政务服务网</a> <a target="_blank" href="http://www.miitbeian.gov.cn/">粤ICP备05070829号-2</a> 网站标识码4400000084
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
const siteData = [{
  title: '国务院部门网站',
  list: [
    { href: 'http://www.mfa.gov.cn', name: '外交部' },
    { href: 'http://www.ndrc.gov.cn', name: '发展改革委' },
    { href: 'http://www.moe.gov.cn', name: '教育部' },
    { href: 'http://www.most.gov.cn', name: '科技部' },
    { href: 'http://www.miit.gov.cn/', name: '工业和信息化部' },
    { href: 'http://www.seac.gov.cn', name: '国家民委' },
    { href: 'http://www.mps.gov.cn', name: '公安部' },
    { href: 'http://www.mos.gov.cn', name: '监察部' },
    { href: 'http://www.mca.gov.cn', name: '民政部' },
    { href: 'http://www.moj.gov.cn/', name: '司法部' },
    { href: 'http://www.mof.gov.cn', name: '财政部' },
    { href: 'http://www.mohrss.gov.cn/', name: '人力资源社会保障部' },
    { href: 'http://www.mlr.gov.cn/', name: '国土资源部' },
    { href: 'http://www.mep.gov.cn/', name: '环境保护部' },
    { href: 'http://www.mohurd.gov.cn/', name: '住房和城乡建设部' },
    { href: 'http://www.mot.gov.cn/', name: '交通运输部' },
    { href: 'http://www.mct.gov.cn/', name: '文化和旅游部' },
    { href: 'http://www.nra.gov.cn/', name: '铁路局' },
    { href: 'http://www.mwr.gov.cn/', name: '水利部' },
    { href: 'http://www.agri.gov.cn/', name: '农业部' },
    { href: 'http://www.mofcom.gov.cn/', name: '商务部' },
    { href: 'http://www.moh.gov.cn/', name: '卫生部' },
    { href: 'http://www.nhfpc.gov.cn/', name: '卫生计生委' },
    { href: 'http://www.pbc.gov.cn/', name: '人民银行' },
    { href: 'http://www.audit.gov.cn/', name: '审计署' },
    { href: 'http://www.sasac.gov.cn/', name: '国资委' },
    { href: 'http://www.customs.gov.cn/', name: '海关总署' },
    { href: 'http://www.chinatax.gov.cn/', name: '税务总局' },
    { href: 'http://www.saic.gov.cn/', name: '工商总局' },
    { href: 'http://www.aqsiq.gov.cn/', name: '质检总局' },
    { href: 'http://www.sapprft.gov.cn', name: '广电总局、新闻出版总署（版权局）' },
    { href: 'http://www.sport.gov.cn/', name: '体育总局' },
    { href: 'http://www.chinasafety.gov.cn/', name: '安全监管总局' },
    { href: 'http://www.stats.gov.cn/', name: '统计局' },
    { href: 'http://www.forestry.gov.cn/', name: '林业局' },
    { href: 'http://www.sipo.gov.cn/', name: '知识产权局' },
    { href: 'http://www.sara.gov.cn/', name: '宗教局' },
    { href: 'http://www.counsellor.gov.cn/', name: '参事室' },
    { href: 'http://www.ggj.gov.cn/', name: '国管局' },
    { href: 'http://www.gqb.gov.cn/', name: '侨办' },
    { href: 'http://www.hmo.gov.cn/', name: '港澳办' },
    { href: 'http://www.chinalaw.gov.cn/', name: '法制办' },
    { href: 'http://www.xinhuanet.com/', name: '新华社' },
    { href: 'http://www.cas.cn/', name: '中科院' },
    { href: 'http://cass.cssn.cn/', name: '社科院' },
    { href: 'http://www.cae.cn/', name: '工程院' },
    { href: 'http://www.drc.gov.cn/', name: '发展研究中心' },
    { href: 'http://www.nsa.gov.cn/', name: '行政学院' },
    { href: 'http://www.cea.gov.cn/', name: '地震局' },
    { href: 'http://www.cma.gov.cn/', name: '气象局' },
    { href: 'http://www.cbrc.gov.cn/', name: '银监会' },
    { href: 'http://www.csrc.gov.cn/', name: '证监会' },
    { href: 'http://www.circ.gov.cn/', name: '保监会' },
    { href: 'http://www.ssf.gov.cn/', name: '社保基金会' },
    { href: 'http://www.nsfc.gov.cn/', name: '自然科学基金会' },
    { href: 'http://www.gwytb.gov.cn/', name: '台办' },
    { href: 'http://www.scio.gov.cn/', name: '新闻办' },
    { href: 'http://www.saac.gov.cn/', name: '档案局' },
    { href: 'http://www.gjxfj.gov.cn/', name: '信访局' },
    { href: 'http://www.chinagrain.gov.cn/', name: '粮食局' },
    { href: 'http://www.sastind.gov.cn/', name: '国防科工局' },
    { href: 'http://www.tobacco.gov.cn/', name: '烟草局' },
    { href: 'http://www.safea.gov.cn/', name: '外专局' },
    { href: 'http://www.soa.gov.cn/', name: '海洋局' },
    { href: 'http://www.sbsm.gov.cn/', name: '测绘局' },
    { href: 'http://www.caac.gov.cn/', name: '民航局' },
    { href: 'http://www.spb.gov.cn/', name: '邮政局' },
    { href: 'http://www.sach.gov.cn/', name: '文物局' },
    { href: 'http://www.sda.gov.cn/WS01/CL0001/', name: '食品药品监管局' },
    { href: 'http://www.satcm.gov.cn/', name: '中医药局' },
    { href: 'http://www.safe.gov.cn/', name: '外汇局' },
    { href: 'http://www.chinacoal-safety.gov.cn/', name: '煤矿安监局' },
    { href: 'http://www.oscca.gov.cn/', name: '密码局' },
    { href: 'http://www.cnsa.gov.cn', name: '航天局' },
    { href: 'http://www.caea.gov.cn', name: '原子能机构' },
    { href: 'http://www.china-language.gov.cn/', name: '国家语委' },
    { href: 'http://www.cpad.gov.cn/', name: '国务院扶贫办' },
    { href: 'http://www.3g.gov.cn/', name: '国务院三峡办' },
  ],
}, {
  title: '驻港澳机构网站',
  list: [
    { href: 'http://www.locpg.gov.cn/', name: '中央政府驻港联络办' },
  ],
}, {
  title: '省政府机构网站',
  list: [
    { href: 'http://www.gd.gov.cn/', name: '省府办公厅' },
    { href: 'http://www.gddrc.gov.cn/', name: '省发展改革委' },
    { href: 'http://www.gdei.gov.cn/', name: '省经济和信息化委' },
    { href: 'http://www.gdedu.gov.cn/', name: '省教育厅' },
    { href: 'http://www.gdstc.gov.cn/', name: '省科技厅' },
    { href: 'http://www.mzzjw.gd.gov.cn', name: '省民族宗教委' },
    { href: 'http://www.gdga.gov.cn/', name: '省公安厅' },
    { href: 'http://www.gdjct.gd.gov.cn/', name: '省监察厅' },
    { href: 'http://www.gdmz.gov.cn/', name: '省民政厅' },
    { href: 'http://www.gdsf.gov.cn/', name: '省司法厅' },
    { href: 'http://www.gdczt.gov.cn/', name: '省财政厅' },
    { href: 'http://www.gdhrss.gov.cn/', name: '省人力资源社会保障厅' },
    { href: 'http://www.gdlr.gov.cn/', name: '省国土资源厅' },
    { href: 'http://www.gdep.gov.cn/', name: '省环境保护厅' },
    { href: 'http://www.gdcic.gov.cn/default.html', name: '省住房城乡建设厅' },
    { href: 'http://www.gdcd.gov.cn/', name: '省交通运输厅' },
    { href: 'http://www.gdwater.gov.cn/', name: '省水利厅' },
    { href: 'http://www.gdagri.gov.cn/', name: '省农业厅' },
    { href: 'http://www.gdf.gov.cn/', name: '省林业厅' },
    { href: 'http://www.gdofa.gov.cn/', name: '省海洋渔业厅' },
    { href: 'http://www.gdcom.gov.cn/', name: '省商务厅' },
    { href: 'http://www.gdwht.gov.cn/', name: '省文化厅' },
    { href: 'http://www.gdwst.gov.cn/', name: '省卫生计生委' },
    { href: 'http://www.gdaudit.gov.cn/', name: '省审计厅' },
    { href: 'http://www.gdfao.gov.cn/', name: '省外办' },
    { href: 'http://www.gdgz.gov.cn', name: '省国资委' },
    { href: 'http://www.gdltax.gov.cn/', name: '广东省税务局' },
    { href: 'http://www.gdgs.gov.cn/', name: '省工商局' },
    { href: 'http://www.gdqts.gov.cn/', name: '省质监局' },
    { href: 'http://www.xwcbgdj.gd.gov.cn/', name: '省新闻出版广电局' },
    { href: 'http://www.gdsports.net/', name: '省体育局' },
    { href: 'http://www.gdsafety.gov.cn', name: '省安全监管局' },
    { href: 'http://www.gdda.gov.cn/', name: '省食品药品监管局' },
    { href: 'http://www.gdstats.gov.cn/', name: '省统计局' },
    { href: 'http://www.gdipo.gov.cn/', name: '省知识产权局' },
    { href: 'http://www.gdta.gov.cn/', name: '省旅游局' },
    { href: 'http://www.qb.gd.gov.cn/', name: '省侨办' },
    { href: 'http://www.hmo.gd.gov.cn/', name: '省港澳办' },
    { href: 'http://www.fzb.gd.gov.cn/', name: '省法制办' },
    { href: 'http://www.gdjrb.gov.cn/', name: '省金融办' },
    { href: 'http://www.gdgrain.gd.gov.cn/', name: '省粮食局' },
    { href: 'http://www.gdjyj.gd.gov.cn/', name: '省监狱局' },
    { href: 'http://www.gdjdj.gov.cn/', name: '省戒毒局' },
    { href: 'http://wzj.gd.gov.cn/', name: '省外专局' },
    { href: 'http://www.gdszyyj.gov.cn/', name: '省中医药局' },
    { href: 'http://www.gdccad.gov.cn/ ', name: '省人防办' },
    { href: 'http://www.hfdsb.gov.cn/', name: '省海防打私办' },
    { href: 'http://www.gdcss.gd.gov.cn/', name: '省参事室 ' },
    { href: 'http://www.gd.gov.cn/govpub/jg/zhb/200606/t20060614_728.htm', name: '省驻沪办' },
    { href: 'http://www.huaxia.com/gdtb/index.html', name: '省台办' },
    { href: 'http://www.bmj.gd.gov.cn/', name: '省保密局' },
    { href: 'http://www.gdwsxf.gov.cn/web/index.html', name: '省信访局' },
    { href: 'http://www.gdbb.gov.cn/', name: '省编办' },
    { href: 'http://www.gdas.gd.cn/', name: '省科学院' },
    { href: 'http://www.gdass.gov.cn/', name: '省社科院' },
    { href: 'http://www.gdaas.cn/', name: '省农科院' },
    { href: 'http://www.gdyjzx.gov.cn/', name: '省发展研究中心' },
    { href: 'http://www.da.gd.gov.cn/', name: '省档案局(馆)' },
    { href: 'http://210.76.65.23/', name: '省地方志办' },
    { href: 'http://www.gdsdjj.gov.cn', name: '省代建局' },
    { href: 'http://www.gddkj.gov.cn', name: '省地质局' },
    { href: 'http://www.gdhgy.org.cn/', name: '省核工业地质局' },
    { href: 'http://www.gdcoop.com/', name: '省供销社' },
    { href: 'http://www.gdic.gov.cn/gdic/', name: '省信息中心' },
    { href: 'http://www.eeagd.edu.cn/portal/', name: '省考试院' },
    { href: 'http://www.gdhed.edu.cn/publicfiles//business/htmlfiles/gdjyyjy/index.html', name: '省教育研究院' },
    { href: 'http://www.fenxi.com.cn/client/centintro/centintro_list.jsp', name: '省测试分析研究所' },
    { href: 'http://www.gdsc.cn/', name: '省科学中心' },
    { href: 'http://www.mzzjyjy.com/', name: '省民族宗教研究院' },
    { href: 'http://www.gdsi.gov.cn/', name: '省社保基金管理局' },
    { href: 'http://www.gdadri.com/', name: '省建筑设计院' },
    { href: 'http://www.gdhighway.gov.cn/', name: '省公路局' },
    { href: 'http://www.gdsw.gov.cn/ ', name: '省水文局' },
    { href: 'http://www.gdbjdd.com.cn/', name: '省北江流域管理局' },
    { href: 'http://www.gdghospital.org.cn/', name: '省人民医院' },
    { href: 'http://www.cdcp.org.cn/', name: '省疾控中心' },
    { href: 'http://www.gqi.org.cn/', name: '省质检院' },
    { href: 'http://www.gdysdz.com/', name: '省有色金属地质局' },
    { href: 'http://www.szdj.com.cn/subproject.html/', name: '深圳市地质局' },
    { href: 'https://www.gdca.gov.cn/framenet/web/index.jsp', name: '省专用通信局' },
  ],
}, {
  title: '地级以上市网站',
  list: [
    { href: 'http://www.gz.gov.cn/', name: '广州' },
    { href: 'http://www.sz.gov.cn/', name: '深圳' },
    { href: 'http://www.zhuhai.gov.cn/', name: '珠海' },
    { href: 'http://www.shantou.gov.cn/', name: '汕头' },
    { href: 'http://www.foshan.gov.cn/', name: '佛山' },
    { href: 'http://www.sg.gov.cn/ ', name: '韶关' },
    { href: 'http://www.heyuan.gov.cn/', name: '河源' },
    { href: 'http://www.meizhou.gov.cn/', name: '梅州' },
    { href: 'http://www.huizhou.gov.cn/', name: '惠州' },
    { href: 'http://www.shanwei.gov.cn/', name: '汕尾' },
    { href: 'http://www.dongguan.gov.cn/', name: '东莞' },
    { href: 'http://www.zs.gov.cn/', name: '中山' },
    { href: 'http://www.jiangmen.gov.cn/', name: '江门' },
    { href: 'http://www.yangjiang.gov.cn/', name: '阳江' },
    { href: 'http://www.zhanjiang.gov.cn/', name: '湛江' },
    { href: 'http://www.maoming.gov.cn/', name: '茂名' },
    { href: 'http://www.zhaoqing.gov.cn/', name: '肇庆' },
    { href: 'http://www.gdqy.gov.cn/', name: '清远' },
    { href: 'http://www.chaozhou.gov.cn/', name: '潮州' },
    { href: 'http://www.jieyang.gov.cn/', name: '揭阳' },
    { href: 'http://www.yunfu.gov.cn/', name: '云浮' },
  ],
}, {
  title: '各省区网站',
  list: [
    { href: 'http://www.beijing.gov.cn/', name: '北京' },
    { href: 'http://www.tj.gov.cn/', name: '天津' },
    { href: 'http://www.hebei.gov.cn/', name: '河北' },
    { href: 'http://www.shanxigov.cn/', name: '山西' },
    { href: 'http://www.nmg.gov.cn/', name: '内蒙古' },
    { href: 'http://www.ln.gov.cn', name: '辽宁' },
    { href: 'http://www.jl.gov.cn', name: '吉林' },
    { href: 'http://www.hlj.gov.cn', name: '黑龙江' },
    { href: 'http://www.shanghai.gov.cn/', name: '上海' },
    { href: 'http://www.jiangsu.gov.cn/', name: '江苏' },
    { href: 'http://www.zhejiang.gov.cn', name: '浙江' },
    { href: 'http://www.ah.gov.cn/', name: '安徽' },
    { href: 'http://www.fujian.gov.cn', name: '福建' },
    { href: 'http://www.jiangxi.gov.cn', name: '江西' },
    { href: 'http://www.shandong.gov.cn/', name: '山东' },
    { href: 'http://www.henan.gov.cn/', name: '河南' },
    { href: 'http://www.hubei.gov.cn/', name: '湖北' },
    { href: 'http://www.hunan.gov.cn/', name: '湖南' },
    { href: 'http://www.gd.gov.cn/', name: '广东' },
    { href: 'http://www.gxzf.gov.cn/', name: '广西' },
    { href: 'http://www.hainan.gov.cn/', name: '海南' },
    { href: 'http://www.cq.gov.cn/', name: '重庆' },
    { href: 'http://www.sc.gov.cn', name: '四川' },
    { href: 'http://www.gzgov.gov.cn/', name: '贵州' },
    { href: 'http://www.yn.gov.cn/', name: '云南' },
    { href: 'http://www.xizang.gov.cn/', name: '西藏' },
    { href: 'http://www.shaanxi.gov.cn/', name: '陕西' },
    { href: 'http://www.gansu.gov.cn/', name: '甘肃' },
    { href: 'http://www.nx.gov.cn/', name: '宁夏' },
    { href: 'http://www.qinghai.gov.cn/', name: '青海' },
    { href: 'http://www.xinjiang.gov.cn/', name: '新疆' },
    { href: 'http://www.gov.hk/', name: '香港' },
    { href: 'http://portal.gov.mo/web/guest/welcomepage', name: '澳门' },
    { href: '', name: '台湾', disabled: true },
  ],
}, {
  title: '省内专业性网站',
  list: [
    { href: 'http://www.gdfp.gov.cn/', name: '广东省扶贫信息网' },
    { href: 'http://www.gdrsks.gov.cn/', name: '广东省人事考试局' },
    { href: 'http://www.gdscse.net/', name: '广东省留学人员服务中心' },
    { href: 'http://www.gdrc.com/', name: '广东人才网' },
    { href: 'http://www.tianditugd.com/index/page/index.html ', name: '天地图·广东' },
    { href: 'http://www.kjcg.gd.cn/', name: '广东省科技成果推广平台' },
    { href: 'http://www.gdsf.gov.cn/sfks/', name: '广东司法考试网' },
    { href: 'http://www.gdgpo.gov.cn/', name: '广东省政府采购网' },
    { href: 'http://www.gpic.gd.cn/', name: '广东省知识产权研究与发展中心（广东省知识产权维权援助中心）' },
    { href: 'http://www.gdzypx.org', name: '广东远程职业培训网 ' },
    { href: 'http://www.gdcx.gov.cn/', name: '公众出行交通信息服务网 ' },
    { href: 'http://www.gradjob.com.cn/defaults/index.jsp', name: '大学生就业在线 ' },
    { href: 'http://www.gdwh.com.cn/', name: '广东文化网' },
    { href: 'http://www.cdcp.org.cn/', name: '广东省疾病预防控制中心' },
    { href: 'http://xwb.gdhed.edu.cn/', name: '广东省学位委员会' },
  ],
}, {
  title: '推荐网站',
  list: [
    { href: 'http://www.rd.gd.cn/', name: '省人大常委会' },
    { href: 'http://www.gdzxb.gov.cn/', name: '省政协' },
    { href: 'http://www.gdcourts.gov.cn/', name: '省高级人民法院' },
    { href: 'http://www.gdcyl.org/', name: '共青团广东省委员会' },
    { href: 'http://www.gdftu.org.cn/', name: '省总工会' },
    { href: 'http://www.gdwomen.org.cn/', name: '省妇联' },
    { href: 'http://www.gddpf.org.cn/', name: '省残联' },
    { href: 'http://www.gdsredcross.org.cn/', name: '省红十字会' },
    { href: 'http://www.gdfpjjh.org.cn/', name: '省扶贫基金会' },
    { href: 'http://www.gd-n-tax.gov.cn/pub/001032/', name: '省国税局 ' },
    { href: 'http://www.grmc.gov.cn/', name: '省气象局' },
    { href: 'http://www.gddzj.gov.cn/', name: '省地震局' },
    { href: 'http://www.infonht.cn/', name: '中国南粤古驿道网' },
    { href: 'http://www.pprd.org.cn/', name: '泛珠三角合作信息网' },
    { href: 'http://www.southcn.com/', name: '南方新闻网' },
    { href: 'http://www.newsgd.com/', name: '南方英文网' },
    { href: 'http://www.echinagov.com/', name: '电子政务工程服务网' },
    { href: 'http://www.people.com.cn/', name: '人民网' },
    { href: 'http://cpc.people.com.cn/', name: '人民网―中国共产党新闻' },
    { href: 'http://www.ce.cn/', name: '中国经济网' },
    { href: 'http://www.gdzf.org.cn/', name: '广东政法网' },
    { href: 'http://www.gdprice.org/', name: '广东价格指数平台' },
    { href: 'http://www.gdrcu.com/', name: '广东农村信用社' },
  ],
}];

export default {
  name: 'GdBizFooter',
  data() {
    return {
      qrcodeGov: require('@/assets/image/layout/qrcode-gov.png'),
      qrcodeApp: require('@/assets/image/layout/qrcode-app.png'),
      qrcodeMp: require('@/assets/image/layout/qrcode-mp.png'),
      siteData,
    };
  },
  methods: {
    onFeedbackClick() {
      let currentUrl = encodeURIComponent(location.href);
      const url = `http://121.43.68.40/exposure/jiucuo.html?site_code=4400000084&url=${currentUrl}`;
      window.open(url);
    },
  },
};
</script>

<style lang="scss">
// 背景色
$bg-color: #fff;
$bg-color1: #bec0c3;
$bg-color2: #e2e2e2;
$bg-color3: #f1f2f3;
// 布局
$container-width: 1200px;
// 正文色
$text-color: #112534;
$text-color-light: #152e48;
// 二级文字色
$text-color2: #444;
// 三级文字色
$text-color3: #777;

ul{
    max-height: 200px;
    overflow: auto;
}
.footer {
  background: $bg-color3;
  border-top: 1px solid #dfe1e2;
  line-height: 1;
  min-width: $container-width;
  margin-top: 100px;

  a {
    color: $text-color2;

    &:hover {
      color: $text-color3;
    }
  }

  // footer 底部网站导航
  &-links {
    color: $text-color2;
    padding: 23px 0;
    text-align: justify;
    line-height: 0;
    // height: 68px;
    // overflow: hidden;
    border-bottom: 1px solid #dfe1e2;

    .gd-icon {
      margin-left: 8px;
    }

    &:before {
      content: "";
      width: 100%;
      display: block;
    }

    &:after {
      content: "";
      width: 100%;
      display: inline-block;
    }

    &-split {
      display: inline-block;
      width: 1px;
      height: 14px;
      background-color: #c5c8ca;
      vertical-align: middle;
    }

    &-item {
      line-height: 24px;
      display: inline-block;
      position: relative;

      &:first-child {
        text-align: left;
      }

      &:last-child {
        text-align: right;
      }
    }

    &-gov {
      padding-left: 20px;
      background: url("~@/assets/image/layout/party.png") no-repeat 0 center
        transparent;
      background-size: 15px 16px;
    }
  }

  &-nav-wrapper {
    margin-top: 48px;
    margin-bottom: 48px;
  }

  &-nav {
    height: 168px;

    &-hd {
      font-size: 14px;
      line-height: 64px;
      color: $text-color;
      padding: 0 24px;
      background-color: #eaebeb;
      h3 {
        font-size: 14px;
        line-height: 64px;
        color: $text-color;
      }
    }

    &-bd {
      //   .clearfix();
      height: 104px;
      background-color: #eaebeb;
    }

    &-link {
      display: block;
      padding: 0 24px;
      line-height: 38px;
    }
  }

  // 底部导航区域联系方式样式
  &-contact {
    padding: 0 24px;
    line-height: 20px;

    &-hotline {
      font-size: 12px;
    }

    &-tel {
      font-size: 20px;
      color: $text-color2;
    }

    &-hint {
      color: $text-color3;
      font-size: 12px;
    }
  }

  &-mp {
    height: 168px;

    &-item {
      position: relative;
      display: block;
      margin-bottom: 3px;
      white-space: nowrap;
      color: $text-color2;
      height: 54px;
      line-height: 54px;
      padding: 0 15px 0 60px;
      background: url("~@/assets/image/layout/qr.png") no-repeat 20px center
        #eaebeb;
      background-size: 23px 23px;

      &:hover {
        .footer-mp-item-hover {
          display: block;
        }
      }

      &-hover {
        // .pop-shadow();
        display: none;
        position: absolute;
        left: 0;
        bottom: 62px;
        width: 100%;
        height: 220px;
        padding: 20px;
        background-color: #fff;
        opacity: 0.97;
        z-index: 99;

        &:after {
          content: "";
          position: absolute;
          bottom: -7px;
          left: 24px;
          width: 14px;
          height: 14px;
          transform: rotate(45deg);
          background-color: #fff;
        }

        & > b {
          display: block;
          margin: 0 auto;
          width: 150px;
          height: 150px;
          background-size: cover;
        }

        .qrcode-gov {
          background-image: url(~@/assets/image/layout/qrcode-gov.png);
        }

        .qrcode-mp {
          background-image: url(~@/assets/image/layout/qrcode-mp.png);
        }

        .qrcode-app {
          background-image: url(~@/assets/image/layout/qrcode-app.png);
        }

        .qrcode-minapp {
          background-image: url(~@/assets/image/layout/minapp.png);
        }

        & > i {
          font-size: 16px;
          color: #000;
          text-align: center;
          display: block;
          font-style: normal;
          line-height: 1.5;
        }
      }
    }
  }

  .support {
    height: 168px;

    a {
      position: relative;
      display: block;
      margin-bottom: 3px;
      white-space: nowrap;
      color: $text-color2;
    }

    &-minapp {
      padding: 0 15px 0 60px;
      line-height: 54px;
      height: 54px;
    }

    &-link {
      background: url("~@/assets/image/layout/cavil.jpg") no-repeat center
        center #eaebeb;
      background-size: 96px 48px;
      float: left;
      height: 111px;
      width: 146px;
      white-space: nowrap;
      overflow: hidden;
      text-indent: 100%;
      margin-right: 3px;
    }

    &-party {
      background: url("~@/assets/image/layout/red.png") no-repeat center center
        #eaebeb;
      background-size: 28px auto;
      float: left;
      height: 111px;
      width: 106px;
      white-space: nowrap;
      overflow: hidden;
      text-indent: 100%;
    }
  }
  .container {
    width: 1200px;
    padding: 0;
    margin: 0 auto;
  }

  // footer 底部版权信息
  &-copyright {
    // .clearfix;
    font-size: 14px;
    color: #727475;
    line-height: 60px;
    text-align: center;
    background: #eaebeb;
    border-top: 1px solid #dfe1e2;

    &-left {
      float: left;
      text-align: left;
    }

    &-right {
      float: right;
      text-align: right;
    }
  }
}
</style>